import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_FILE = 'Oakvale Credit Union logo1.png';

export default function OakvaleLogo({ className = '' }) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const logoSrc = encodeURI(`${base}/${LOGO_FILE}`);

  return (
    <Link to="/" className="flex items-center">
      <img
        src={logoSrc}
        alt="Oakvale Credit Union"
        className={`max-h-11 sm:max-h-12 md:max-h-14 lg:max-h-16 w-auto max-w-[min(100vw-6rem,440px)] object-contain object-left transition-all duration-300 ${className}`.trim()}
      />
    </Link>
  );
}
